import Check from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import MuiStep from '@mui/material/Step';
import MuiStepLabel from '@mui/material/StepLabel';
import MuiStepper from '@mui/material/Stepper';
import type { StepIconProps } from '@mui/material/StepIcon';

export type StepperProps = {
  steps: string[];
  activeStep: number;
  /** @default 'horizontal' */
  orientation?: 'horizontal' | 'vertical';
};

function SmStepIcon(props: StepIconProps) {
  const { active, completed, className, icon: _stepNumber, ...rest } = props;
  const state = completed ? 'completed' : active ? 'active' : 'pending';
  return (
    <Box
      component="span"
      className={['SmStepIcon-root', `SmStepIcon-${state}`, className].filter(Boolean).join(' ')}
      {...rest}
    >
      {completed ? <Check className="SmStepIcon-check" /> : null}
      {active && !completed ? <span className="SmStepIcon-innerDot" /> : null}
    </Box>
  );
}

export function Stepper({ steps, activeStep, orientation = 'horizontal' }: StepperProps) {
  return (
    <MuiStepper
      className="SmStepper-root"
      activeStep={activeStep}
      orientation={orientation}
      alternativeLabel={orientation === 'horizontal'}
    >
      {steps.map(label => (
        <MuiStep key={label}>
          <MuiStepLabel StepIconComponent={SmStepIcon}>{label}</MuiStepLabel>
        </MuiStep>
      ))}
    </MuiStepper>
  );
}
